import { Link } from "react-router-dom";
import { H4, Image, LI, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { getCurrentUser } from "../../../services/auth";
import { getStoreName } from "../../../services/helper";

export default function ProfileHeaderNonVendor() {
  const logout = () => {
    localStorage.clear();
  };

  const user = getCurrentUser();
  const store_name = getStoreName();

  return (
    <LI className="profile-nav onhover-dropdown">
      <div className="onhover-click">
        <div className="sidebar-image">
          <Image src={dynamicImage(`user.png`)} alt="profile" />
          <span className="status status-success"></span>
        </div>
        <div className="sidebar-content">
          <H4>{user && user.user.display_name}</H4>
          <span className="f-12 f-w-600 f-light">{store_name}</span>
        </div>
      </div>
      <UL className="profile-dropdown onhover-show-div simple-list">
        <LI>
          <Link onClick={logout} to={`${process.env.PUBLIC_URL}/login`}>
            <div className="profile-icon">
              <SvgIcon iconId="login" />
            </div>
            <span>{"Log out "}</span>
          </Link>
        </LI>
      </UL>
    </LI>
  );
}
